import { jsxs as d, jsx as c } from "react/jsx-runtime";
import { useRef as m, useEffect as p } from "react";
const v = ({
  id: l,
  name: t,
  value: i,
  label: n,
  checked: s,
  onChange: b,
  disabled: f,
  large: o,
  indeterminate: r,
  ariaLabelledBy: h,
  reference: x,
  testId: e
}) => {
  const u = m(null), a = x ?? u;
  return p(() => {
    a.current && (a.current.indeterminate = r ?? !1);
  }, [r, a]), /* @__PURE__ */ d(
    "div",
    {
      className: `Checkbox${o ? " Checkbox--large" : ""}`,
      "aria-labelledby": h,
      "data-testid": e ? `${e}-wrapper` : void 0,
      children: [
        /* @__PURE__ */ c(
          "input",
          {
            className: `Checkbox-button${o ? " Checkbox--large" : ""}`,
            id: l,
            name: t,
            type: "checkbox",
            value: i,
            checked: s,
            onChange: b,
            disabled: f,
            ref: a,
            "data-testid": e ? `${e}-input` : void 0
          }
        ),
        /* @__PURE__ */ c(
          "label",
          {
            htmlFor: l,
            className: "Checkbox-label",
            "data-testid": e ? `${e}-label` : void 0,
            children: n
          }
        )
      ]
    }
  );
};
export {
  v as Checkbox
};
//# sourceMappingURL=Checkbox.mjs.map
